import React from 'react';
import loader from  '../loader/loader.svg';
import  "./loader.css";
import { Dimmer, Loader, Image, Segment } from "semantic-ui-react";
import { Box } from '@mui/system';


const Loading=({props})=>(
    <div className='Loader_sec'>
        <div className='loading_under'>
        <Dimmer  className="ui blue">
        <Loader inverted className="ui  text loader loadingText d-flex justify-content-center align-items-center" style={{"flexDirection":"column"}}>
        <Box component="p" sx={{color:'#fff !important'}}>{props}</Box>
            <Box sx={{textAlign:'center'}}>
                <img src={loader} width="120px" alt='loader images' />
            </Box>
        </Loader>      
        </Dimmer>
        </div>
    </div>
);
export default Loading;




